import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { findRoute } from '../../routes.js';

const setMeta = (selector, attrs) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement('meta');
    document.head.appendChild(tag);
  }
  Object.entries(attrs).forEach(([key, value]) => tag.setAttribute(key, value));
};

/**
 * Keeps the document title and description in step with the current route.
 *
 * The prerendered HTML already carries the right values for a cold load —
 * this only covers in-app navigation, where no document is fetched and the
 * title would otherwise still read whatever page the visitor first landed
 * on. Both read the same route table, so the two can't disagree.
 */
export function DocumentMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = findRoute(pathname)?.meta ?? findRoute('/404').meta;
    document.title = meta.title;
    if (meta.description) {
      setMeta('meta[name="description"]', { name: 'description', content: meta.description });
      setMeta('meta[property="og:description"]', {
        property: 'og:description',
        content: meta.description,
      });
    }
    setMeta('meta[property="og:title"]', { property: 'og:title', content: meta.title });
  }, [pathname]);

  return null;
}
